import React from 'react';
import styled from 'styled-components';
import { Container, Flex } from '../../styles/components.js';
import { AppImages } from '../../assets/index.js';
import { FaTwitter, FaInstagram } from 'react-icons/fa';

const FooterWrapper = styled.footer`
  background-color: ${({ theme }) => theme.colors.surface};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 2.5rem 0;
`;

const FooterInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
`;

const LogoBrand = styled.div`
  font-size: 1.15rem;
  font-weight: 800;
  font-family: 'Space Grotesk', sans-serif;
  color: ${({ theme }) => theme.colors.textDark};
  letter-spacing: -0.02em;

  span {
    background: ${({ theme }) => theme.colors.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const AvailabilityBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 14px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: #22c55e12;
  border: 1px solid #22c55e30;
  font-size: 0.78rem;
  font-weight: 700;
  color: #16a34a;
  letter-spacing: 0.04em;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #22c55e;
    flex-shrink: 0;
    animation: pulse 2s infinite;
    box-shadow: 0 0 6px #22c55e80;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 0.6rem;
`;

const SocialLink = styled.a`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textGray};
  font-size: 0.95rem;
  transition: all 0.25s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.gradient};
    color: #fff;
    border-color: transparent;
    transform: translateY(-3px);
    box-shadow: ${({ theme }) => theme.shadows.glowSm};
  }

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    transition: all 0.25s ease;
  }

  &:hover img {
    filter: brightness(0) invert(1);
  }
`;

const Copyright = styled.p`
  font-size: 0.82rem;
  color: ${({ theme }) => theme.colors.textGray};
  margin: 0;
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterInner>
          <Flex direction="column" gap="0.5rem">
            <LogoBrand>CODE<span>X</span>MOBILE</LogoBrand>
            <Copyright>© {new Date().getFullYear()} Tauseef Ahmed. All rights reserved.</Copyright>
          </Flex>

          <AvailabilityBadge>Available for Hire</AvailabilityBadge>

          <SocialLinks>
            <SocialLink href="https://github.com/TauseefAlpha" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <img src={AppImages.githubLogo} alt="GitHub" />
            </SocialLink>
            <SocialLink href="https://www.linkedin.com/in/tauseef-ahmad-a2107523b/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <img src={AppImages.linkedin} alt="LinkedIn" />
            </SocialLink>
            <SocialLink href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </SocialLink>
            <SocialLink href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </SocialLink>
          </SocialLinks>
        </FooterInner>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;